(function () {
    'use strict';

    angular
        .module('infinite-scroll')
        .value('THROTTLE_MILLISECONDS', 250);

    angular
        .module('franchisee-portal.configs', [])
        .config(StConfig)
        .config(QuillConfig)
        .config(InterceptorConfig);

    /** @ngInject */
    function StConfig(stConfig) {
        stConfig.sort.delay = 100;
        stConfig.pipe.delay = 700;
    }

    /** @ngInject */
    function InterceptorConfig($httpProvider) {
        $httpProvider.interceptors.push('cacheFileFactory');
        $httpProvider.interceptors.push('authenticationFactory');
    }

    /** @ngInject */
    function QuillConfig(ngQuillConfigProvider) {
        ngQuillConfigProvider.set({
            modules: {
                toolbar: [
                    ['bold', 'italic', 'underline', 'strike'],
                    ['blockquote', 'code-block'],

                    [{
                        'header': 1
                    }, {
                        'header': 2
                    }],

                    [{
                        'list': 'ordered'
                    }, {
                        'list': 'bullet'
                    }],

                    [{
                        'script': 'sub'
                    }, {
                        'script': 'super'
                    }],

                    [{
                        'indent': '-1'
                    }, {
                        'indent': '+1'
                    }],

                    [{
                        'size': ['small', false, 'large', 'huge']
                    }],
                    [{
                        'header': [1, 2, 3, 4, 5, 6, false]
                    }],

                    [{
                        'color': []
                    }, {
                        'background': []
                    }],

                    [{
                        'font': []
                    }],

                    [{
                        'align': []
                    }],

                    ['clean'], // remove formatting button

                    ['link', 'video'] // link and image, video
                ]
            },
            theme: 'snow',
            placeholder: '',
            readOnly: false,
            bounds: document.body
        })
    }
}());